<template>
  <div class="lotti-therapist-container">

    <div class="lotti-grid-row lotti-grid-row-mid">

      <div class="lotti-grid-col lotti-grid-col-66">

        <div class="lotti-module">

          <div class="lotti-module-title">Logopädin erstellen</div>

          <el-form :model="therapistForm" :rules="therapistRules" label-width="120px" ref="therapistForm" class="lotti-module-form">

            <div class="lotti-form-separator-50">

              <el-form-item label="Vorname" prop="firstname">
                <el-input placeholder="Bitte Vornamen eingeben" v-model="therapistForm.firstname"></el-input>
              </el-form-item>

              <el-form-item label="Nachname" prop="lastname">
                <el-input placeholder="Bitte Nachname eingeben" v-model="therapistForm.lastname"></el-input>
              </el-form-item>

              <el-form-item label="Zugew. Dienst" prop="serviceId">
                <el-select placeholder="Bitte Dienst auswählen" v-model="therapistForm.serviceId">
                  <el-option
                      v-for="item in serviceOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

            </div>

            <div class="lotti-form-separator-50">

              <el-form-item label="E-Mail" prop="email">
                <el-input placeholder="Bitte E-Mail eingeben" v-model="therapistForm.email"></el-input>
              </el-form-item>

              <el-form-item label="Wochenlektionen" prop="weeklyLesson">
                <el-input-number
                    style="width: 100%"
                    v-model="therapistForm.weeklyLesson"
                    controls-position="right"
                    :min="1"
                    :max="28"
                    :step="0.1">
                </el-input-number>
              </el-form-item>

              <el-form-item label="Gültig ab" prop="validFrom">
                <el-date-picker
                    style="width: 100%"
                    v-model="therapistForm.validFrom"
                    :picker-options="{ firstDayOfWeek: 1}"
                    type="date"
                    format="dd.MM.yyyy"
                    placeholder="Gültigkeitsdatum">
                </el-date-picker>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="submitData">Speichern</el-button>
                <el-button type="secondary" @click="$router.go(-1)">Zurück</el-button>
              </el-form-item>

            </div>

          </el-form>

        </div>
      </div>

    </div>

  </div>
</template>


<script>
import Vue from '../../main.js';
import auth from '../../auth.js';
import datePickerHelper from '../../Helpers/DatePickerHelper.js';
import validation from '../../Helpers/ValidationHelper';
import notification from '../../Helpers/NotificationHelper';


export default {

  data() {
    return {
      auth: auth,

      datePickerHelper: datePickerHelper,

      therapistForm: {
        firstname: null,
        lastname: null,
        serviceId: null,
        email: null,
        weeklyLesson: null,
        validFrom: null,
      },

      serviceOptions: [],

      therapistRules: {
        firstname: [
          validation.getMinMaxValidationObject(2, 45, 'change'),
          validation.getCustomAlphaValidationObject('change'),
          validation.getRequiredValidationObject('change')
        ],
        lastname: [
          validation.getMinMaxValidationObject(2, 45, 'change'),
          validation.getCustomAlphaValidationObject('change'),
          validation.getRequiredValidationObject('change')
        ],
        serviceId: [
          validation.getRequiredValidationObject('change')
        ],
        email: [
          validation.getRequiredValidationObject('change'),
          validation.getEmailValidationObject('change'),
        ],
        weeklyLesson: [
          validation.getRequiredValidationObject('change'),
        ],
        validFrom: [
          validation.getRequiredValidationObject('change'),
        ],
      },
    }
  },

  methods: {

    isStatusDisabled() {
      return false
    },

    submitData() {

      this.$refs['therapistForm'].validate((valid) => {

        if (valid) {

          Vue.http.post(
              'api/v1/therapist/create',
              {
                firstname: this.therapistForm.firstname,
                lastname: this.therapistForm.lastname,
                serviceId: this.therapistForm.serviceId,
                email: this.therapistForm.email,
                weeklyLesson: this.therapistForm.weeklyLesson,
                validFrom: datePickerHelper.formatUTCDateTimeUS(this.therapistForm.validFrom),
              }
          ).then(response => {

            //push back to lead (in oder to show update therapist management table)
            this.$router.push('/lead');

            //show success msg
            notification.showSuccess(this, 'Logopädin wurden erfolgreich erstellt');

          }, error => {
            notification.showError(this, 'Logopädin konnte nicht erstellt werden');
          })
        }
      })
    },

    getAllServices() {
      Vue.http.get(
          'api/v1/service/get-all'
      ).then(response => {
        this.serviceOptions = response.data.map(item => {
          return { value: item.id, label: item.name };
        });
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

  },

  beforeMount() {
    //get all therapists in selected service
    this.getAllServices();
  },
}

</script>